import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { ObservableMedia } from '@angular/flex-layout';
import { MatSidenav } from '@angular/material';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { SessionService, SessionData } from './common/session.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild('sidenav') sidenav: MatSidenav;
  mobileMode = false; // TODO make true on first load when 'xs'
  sidenavMode = 'side';
  sidenavOpened = false;
  hasSession = false;
  private mediaWatcher: Subscription;
  private sessionWatcher: Subscription;
  private forceHideSidebar = false;

  constructor(
    public session: SessionService,
    private media: ObservableMedia,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.mediaWatcher = this.media.subscribe(change => {
      if ( change.mqAlias === 'xs' ) {
        this.mobileMode = true;
        this.sidenavMode = 'over';
        this.sidenavOpened = false;
      } else {
        this.mobileMode = false;
        this.sidenavMode = 'side';
        this.sidenavOpened = this.hasSession && !this.forceHideSidebar;
      }
    });

    this.sessionWatcher = this.session.observable().subscribe(sess => {
      if ( sess ) {
        this.hasSession = true;
        this.sidenavOpened = !this.mobileMode;
      } else {
        this.hasSession = false;
        this.sidenavOpened = false;
      }
    })

    this.router.events.subscribe(event => {
      if ( event instanceof NavigationEnd && this.hasSession ) {
        if ( event.url === '/funds/print' ) { // TODO use ActivatedRoute.data
          this.forceHideSidebar = true;
          this.sidenavOpened = false;
        } else {
          this.forceHideSidebar = false;
          this.sidenavOpened = true;
        }
      }
    })
  }

  ngOnDestroy() {
    this.mediaWatcher.unsubscribe();
    this.sessionWatcher.unsubscribe();
  }

  toggleSidenav() {
    this.sidenav.toggle();
  }

  logout() {
    this.session.destroy().then(() => {
      this.router.navigateByUrl('/login');
    });
  }
}



// WEBPACK FOOTER //
// /srv/src/app/app.component.ts